import PropTypes from "prop-types";
import { Fragment, memo, useCallback, useState } from "react";
import LazyLoad from "react-lazyload";
import { MEDIA_TYPE, VIDEO_AUTOPLAY } from "app/constants";
import Paragraphs from "app/pages/.shared/Paragraphs.jsx";
import Video from "app/pages/.shared/Video/Video";
import SlideShow from "app/pages/.shared/Slideshow/SlideShow";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg.jsx";
import { videoPropTypes } from "app/utils/propTypes";
import "./Destination.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const DESTINATION_MEDIA_SIZES = {
	small: { width: 768 },
	medium: { width: 978 },
	large: { height: 300, width: 560 },
	xlarge: { height: 300, width: 560 },
};

const Destination = ({
	paragraphs = [],
	photo = {},
	video = {},
	showVideoOnModal = false,
	title,
}) => {
	const [isVideoFullscreen, setVideoFullscreen] = useState(false);

	const openVideoFullscreen = useCallback(() => {
		setVideoFullscreen(true);
	}, []);

	const closeVideoFullscreen = useCallback(() => {
		setVideoFullscreen(false);
	}, []);

	let videoElement = false;

	if (photo.url && video.url) {
		video.type = MEDIA_TYPE.VIDEO;
		video.autoplay = VIDEO_AUTOPLAY.TRUE;

		if (showVideoOnModal) {
			videoElement = (
				<Fragment>
					<div
						className="destination__image destination__image--video"
						onClick={openVideoFullscreen}
					>
						<div className="destination__play">
							<i className="icon icon--play-dark" />
						</div>

						<ProgressiveImg
							sizes={DESTINATION_MEDIA_SIZES}
							src={photo.url}
							alt="destination"
							thumbnail={photo.thumbnail}
						/>
					</div>
					<SlideShow
						isOpened={isVideoFullscreen}
						photos={[video]}
						close={closeVideoFullscreen}
					/>
				</Fragment>
			);
		} else {
			videoElement = (
				<div className="destination__image">
					<LazyLoad once offset={300}>
						<Video {...video} />
					</LazyLoad>
				</div>
			);
		}
	} else if (photo.url) {
		videoElement = (
			<div className="destination__image">
				<ProgressiveImg
					sizes={DESTINATION_MEDIA_SIZES}
					src={photo.url}
					alt="destination"
					thumbnail={photo.thumbnail}
				/>
			</div>
		);
	}

	return (
		<div id="destination" className="destination">
			{title && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL4}
					isBold
					className="destination__title"
					component="h2"
				>
					{title}
				</Typography>
			)}

			{videoElement}

			<div className="destination__paragraphs">
				<Paragraphs paragraphs={paragraphs} enableHTMLFormatting={true} />
			</div>
		</div>
	);
};

Destination.propTypes = {
	showVideoOnModal: PropTypes.bool,
	paragraphs: PropTypes.arrayOf(PropTypes.string),
	photo: PropTypes.object,
	video: videoPropTypes,
	title: PropTypes.string,
};

export default memo(Destination);
